<template>
  <div class="continer">
    <img src="../../assets/img/组 102.png" alt="">
    <img src="../../assets/img/组 103.png" alt="">
    <img src="../../assets/img/组 104.png" alt="">
    <img src="../../assets/img/组 105.png" alt="">
  </div>
</template>
<script>
// import { pictureList } from '../../api/user/index'
import { ERR_OK } from '../../api/common/config'
export default {
  data() {
    return {
      
    }
  },
  mounted(){
    // this._pictureList()
  },
  methods: {
    _pictureList(){
      pictureList().then((res)=>{
        if(res.data.isok === ERR_OK){
          // console.log(res)
        }
      })
    }
  },
}
</script>
<style lang="stylus" scoped>
.continer
  width 1200px
  margin 0 auto
  display flex
  flex-wrap wrap
  justify-content space-between
  margin-bottom 60px
  img 
    display block
    width 280px
    height 200px
</style>